class Tabs {
    constructor(buttonsSelector, descriptionsSelector) {
      this.buttons = document.querySelectorAll(buttonsSelector);
      this.descriptions = document.querySelectorAll(descriptionsSelector);
      this.clicks = 0;
      this.init();
    }
  
    init() {
      this.buttons.forEach(button => {
        button.addEventListener('click', (e) => this.handleButtonClick(e));
      });
  
      if (this.buttons.length > 0) {
        this.buttons[0].click();
      }
    }

    scrollToComp() {
      const tabSect = document.querySelector('.tabs-scroll');

      if (tabSect) {
        const rect = tabSect.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        const offsetTop = rect.top + scrollTop;

        window.scrollTo({
          top: offsetTop - 100,
          behavior: 'smooth',
        });
      }
    }
  
    handleButtonClick(event) {
      const targetDescription = event.target.getAttribute('data-control');
  
      this.descriptions.forEach(description => {
        description.classList.add('hide');
      });
  
      const activeDescription = document.querySelector(`.tabs__tab[data-desc="${targetDescription}"]`);
      if (activeDescription) {
        activeDescription.classList.remove('hide');
      }
  
      this.buttons.forEach(button => {
        button.setAttribute('aria-pressed', 'false');
      });
  
      event.target.setAttribute('aria-pressed', 'true');

      if(this.clicks != 0) {
        this.scrollToComp();
      }
      this.clicks = this.clicks + 1;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new Tabs ('.tabs__control', '.tabs__tab');
  });
  


  class PaginationTabs {
    constructor(el) {
      this.el = el;
  
      this.bindListeners();
    }
  
    bindListeners() {
      this.el.addEventListener("click", this.handleClick.bind(this));
      //window.addEventListener("resize", this.handleResize);
      this.count();
    }
  
    handleClick() {
      const hiddenItems = document.querySelectorAll(".tabs__body-content-item.hide");
  
      Array.from(hiddenItems).slice(0, 6).forEach(item => {
        item.classList.add("show");
        item.classList.remove("hide");
      });
  
      const remainingHide = Array.from(hiddenItems).some(item => item.classList.contains("hide"));
      
      this.count();
  
      if (!remainingHide) {
        this.el.classList.add('hide');
      }
    }

    count() {
      const countDiv = this.el.querySelector('.count');
      const hiddenItems = document.querySelectorAll(".tabs__body-content-item.hide");
      countDiv.innerHTML = '[' + hiddenItems.length + ']';
    }
  }
  
  function initPaginationTabs() {
    const showMorebtn = document.querySelector(".tabs__pagination .btn");
  
    if (showMorebtn) {
      new PaginationTabs(showMorebtn);
    }
  }
  
  initPaginationTabs();
  